unit View.Origem_Csosn.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewOrigem_CsosnList = class(TForm)
    btNew: TButton;
    Origem_CsosnDataset: TXDataWebDataSet;
    Origem_CsosnDatasetnome: TStringField;
    Origem_CsosnDatasetcodigo: TIntegerField;
    Origem_CsosnDatasetexcluido: TBooleanField;
    Origem_CsosnDatasetinclusao: TDateTimeField;
    Origem_CsosnDatasetalteracao: TDateTimeField;
    Origem_CsosnDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewOrigem_CsosnList: TFViewOrigem_CsosnList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewOrigem_CsosnList }

procedure TFViewOrigem_CsosnList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewOrigem_CsosnList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewOrigem_CsosnList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewOrigem_CsosnList, AElementID, Result, @AfterCreate);
end;

procedure TFViewOrigem_CsosnList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewOrigem_CsosnList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewOrigem_CsosnList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Origem_CsosnDataset.Connection.Model.DefaultSchema.FindEntityType(Origem_CsosnDataset.EntitySetName),
      Origem_CsosnDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewOrigem_CsosnList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('origem_csosn', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Origem_CsosnDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewOrigem_CsosnList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.origem_csosn.list.pagination.info');
  btNew := TButton.Create('view.origem_csosn.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.origem_csosn.list.table');
  cbPageSize := TComboBox.Create('view.origem_csosn.list.cbPageSize');
  edSearch := TEdit.Create('view.origem_csosn.list.search');
  lcPaginator := TListControl.Create('view.origem_csosn.list.pagination');
  Origem_CsosnDataset := TXDataWebDataSet.Create(Self);
  Origem_CsosnDatasetnome := TStringField.Create(Self);
  Origem_CsosnDatasetcodigo := TIntegerField.Create(Self);
  Origem_CsosnDatasetexcluido := TBooleanField.Create(Self);
  Origem_CsosnDatasetinclusao := TDateTimeField.Create(Self);
  Origem_CsosnDatasetalteracao := TDateTimeField.Create(Self);
  Origem_CsosnDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Origem_CsosnDataset.BeforeLoadDFMValues;
  Origem_CsosnDatasetnome.BeforeLoadDFMValues;
  Origem_CsosnDatasetcodigo.BeforeLoadDFMValues;
  Origem_CsosnDatasetexcluido.BeforeLoadDFMValues;
  Origem_CsosnDatasetinclusao.BeforeLoadDFMValues;
  Origem_CsosnDatasetalteracao.BeforeLoadDFMValues;
  Origem_CsosnDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewOrigem_CsosnList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo';
      Title := 'codigo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Origem_CsosnDataset.SetParentComponent(Self);
    Origem_CsosnDataset.Name := 'Origem_CsosnDataset';
    Origem_CsosnDataset.EntitySetName := 'Origem_Csosn';
    Origem_CsosnDataset.Connection := DMConnection.ApiConnection;
    Origem_CsosnDataset.Left := 72;
    Origem_CsosnDataset.Top := 144;
    Origem_CsosnDatasetnome.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetnome.Name := 'Origem_CsosnDatasetnome';
    Origem_CsosnDatasetnome.FieldName := 'nome';
    Origem_CsosnDatasetnome.Required := True;
    Origem_CsosnDatasetnome.Size := 255;
    Origem_CsosnDatasetcodigo.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetcodigo.Name := 'Origem_CsosnDatasetcodigo';
    Origem_CsosnDatasetcodigo.FieldName := 'codigo';
    Origem_CsosnDatasetcodigo.Required := True;
    Origem_CsosnDatasetexcluido.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetexcluido.Name := 'Origem_CsosnDatasetexcluido';
    Origem_CsosnDatasetexcluido.FieldName := 'excluido';
    Origem_CsosnDatasetinclusao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetinclusao.Name := 'Origem_CsosnDatasetinclusao';
    Origem_CsosnDatasetinclusao.FieldName := 'inclusao';
    Origem_CsosnDatasetalteracao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetalteracao.Name := 'Origem_CsosnDatasetalteracao';
    Origem_CsosnDatasetalteracao.FieldName := 'alteracao';
    Origem_CsosnDatasetexclusao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetexclusao.Name := 'Origem_CsosnDatasetexclusao';
    Origem_CsosnDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Origem_CsosnDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Origem_CsosnDataset.AfterLoadDFMValues;
    Origem_CsosnDatasetnome.AfterLoadDFMValues;
    Origem_CsosnDatasetcodigo.AfterLoadDFMValues;
    Origem_CsosnDatasetexcluido.AfterLoadDFMValues;
    Origem_CsosnDatasetinclusao.AfterLoadDFMValues;
    Origem_CsosnDatasetalteracao.AfterLoadDFMValues;
    Origem_CsosnDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
